// extracted by css-extract-rspack-plugin
export default {"codeViewer":"aWq6Qehc8Ggzj00i"};